import { Vertical } from '@origin-digital/layout';
import { Modal, Text } from '@origin-digital/style-guide';
import * as React from 'react';
import styled from 'styled-components';
import AccountNumberOnBill from '../../../../../images/account-number-on-bill.jpg';
import AccountNumberOnContract from '../../../../../images/account-number-on-contract.jpg';

interface AccountNumberInfoModalViewProps {
  onDismiss: () => void;
}

interface StyledInfoTextProps {
  topPadding?: boolean;
}

const StyledImage = styled.img`
  padding: 4px;
  width: 98%;
`;
StyledImage.displayName = 'StyledImage';

const ModalBody = styled.div`
  overflow: auto;
`;

const StyledInfoText = styled(Text)`
  margin-top: ${(props: StyledInfoTextProps) => (props.topPadding ? `24px` : `0`)};
  margin-bottom: 24px;
`;
StyledInfoText.displayName = 'StyledInfoText';

const AccountNumberInfoModalView: React.FC<AccountNumberInfoModalViewProps> = ({ onDismiss }) => {
  return (
    <Modal
      data-id="find-account-number-modal"
      accessibilityModalLabel="Find your account number"
      accessibilityCloseLabel="Close"
      transparent
      title="Find your account number"
      onDismiss={onDismiss}
    >
      <Vertical>
        <ModalBody>
          <StyledInfoText size="sm" data-id="got-bill-text" markdown>
            **Got a bill?** Look in the 'Your Account Details' section.
          </StyledInfoText>
          <StyledImage src={AccountNumberOnBill} />
          <StyledInfoText size="sm" data-id="no-bill-text" markdown topPadding>
            **No bill?** Look in the 'Your contact & supply details’ section of your contract.
          </StyledInfoText>
          <StyledImage src={AccountNumberOnContract} />
        </ModalBody>
      </Vertical>
    </Modal>
  );
};

export { AccountNumberInfoModalView };
